<script setup>
    import { ref, watchEffect } from 'vue';
    import axios from 'axios';
    import { getFromAPI } from '../functionCollection';
    // import * as bootstrap from 'bootstrap';

    const props = defineProps(['saveUrl', 'state', 'fetchUrl']);

    // base structure of the new tarif object
    const newTarif = ref({
        tarif: null,
        name: null,
        price: null,
        description: null,
        group: "parken24",
        disabled: false,
        visible: true,
        noRental: false,
    });
    const priceNotNeeded = ref(false); // feels backwards, but makes the v-model with the checkbox easier.
    const submitResult = ref(null);
    const submitError = ref(null);

    // initial fetch. changes disabled, visible and noRental from default if needed.
    watchEffect(async () => {
        if (typeof props.fetchUrl !== 'undefined') {
            newTarif.value = await getFromAPI(props.fetchUrl);
            if (newTarif.value.disabled === 1) {
                newTarif.value.disabled = true;
            }
            if (newTarif.value.visible === 1) {
                newTarif.value.visible = true;
            }
            if (newTarif.value.noRental === 1) {
                newTarif.value.noRental = true;
            }
        }
    });

    // saves a wholly new tarif. submitResult/Error are used to display an appropriate message below.
    async function saveNewTarif() {
        submitResult.value = null;
        submitError.value = null;
        await axios.post(props.saveUrl, newTarif.value)
        .then(function (response) {
            submitResult.value = response;
        }).catch(function (error) {
            submitError.value = error;
        });
    }

    // updates an already existing tarif. submitResult/Error are used to display an appropriate message below.
    async function updateTarif() {
        submitResult.value = null;
        submitError.value = null;
        await axios.put(props.saveUrl, newTarif.value)
        .then(function (response) {
            submitResult.value = response;
        }).catch(function (error) {
            submitError.value = error;
        });
    }

</script>
<template>
    <form>
        <div class="form-group">
            <label for="tarif">Tarifnummer (*)</label>
            <input
                id="tarif"
                type="text"
                v-model="newTarif.tarif"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.tarif !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.tarif !== 'undefined')">
                {{ submitError.response.data.tarif[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="tarif">Name (*)</label>
            <input
                id="tarif"
                type="text"
                v-model="newTarif.name"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.name !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.name !== 'undefined')">
                {{ submitError.response.data.name[0] }}
            </div>
        </div>

        <div class="form-group">
            <div class="form-check">
                <input
                    type="checkbox"
                    class="form-check-input"
                    v-model="priceNotNeeded"
                />
                <label class="form-check-label" for="notNeedPrice">
                    Kein Preis benötigt
                </label>
            </div>
            <!-- Maybe add error data? -->
        </div>

        <div class="form-group" v-if="priceNotNeeded">
            <label for="tarif">Beschreibung (*) (da kein Preis benötigt)</label>
            <input
                id="tarif"
                type="text"
                v-model="newTarif.description"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.description !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.description !== 'undefined')">
                {{ submitError.response.data.description[0] }}
            </div>
        </div>

        <div class="form-group" v-if="!priceNotNeeded">
            <label for="tarif">Preis (*)</label>
            <input
                id="tarif"
                type="text"
                v-model="newTarif.price"
                :class="{
                    'form-control': true,
                    'is-valid': (submitResult !== null),
                    'is-invalid': (submitError !== null && typeof submitError.response.data.price !== 'undefined'),
                }"
            />
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.price !== 'undefined')">
                {{ submitError.response.data.price[0] }}
            </div>
        </div>

        <div class="form-group">
            <label for="group">Tarifgruppe</label>
            <select
                v-model="newTarif.group"
                :class="{
                    'form-select form-control': true,
                    'form-select is-valid': (submitResult !== null),
                    'form-select is-invalid': (submitError !== null && typeof submitError.response.data.group !== 'undefined'),
                }"
            >
                <option value="parken24">Parken 24</option>
                <option value="jobparken">Job-Parken</option>
                <option value="homeparken">Home-Parken</option>
                <option value="homeparkenplus">Home-Parken Plus</option>
                <option value="uka">UKA</option>
                <option value="rmk">Rhein-Maas-Klinikum</option>
                <option value="fra">Uniklinik Franziskus</option>
            </select>
            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.group !== 'undefined')">
                {{ submitError.response.data.group[0] }}
            </div>
        </div>

        <div class="form-check">
            <input id="disabled" type="checkbox" class="form-check-input" v-model="newTarif.disabled" />
            <label for="disabled" class="form-check-label">Deaktiviert</label>
        </div>

        <div class="form-check">
            <input id="visible" type="checkbox" class="form-check-input" v-model="newTarif.visible" />
            <label for="visible" class="form-check-label">Sichtbar</label>
        </div>

        <div class="form-check">
            <input id="noRental" type="checkbox" class="form-check-input" v-model="newTarif.noRental" />
            <label for="noRental" class="form-check-label">Keine Vermietung</label>
        </div>

        <button v-if="props.state === 'edit'" type="submit" class="btn btn-primary" @click.prevent="updateTarif()">
            Tarif ändern
        </button>
        <button v-if="props.state === 'create'" type="submit" class="btn btn-primary" @click.prevent="saveNewTarif()">
            Tarif erstellen
        </button>
    </form>

    <div class="alert alert-success" role="alert" v-if="submitResult !== null && (submitResult.status === 201 || submitResult.status === 200)">
        <span v-if="props.state === 'create'">Tarif erfolgreich angelegt.</span>
        <span v-if="props.state === 'edit'">Tarif erfolgreich geändert.</span>
    </div>

</template>
